import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'


const firebaseConfig = {
  apiKey: "AIzaSyChbukS2j5XnbLv3M-e_IdLNX-Tktg7oVA",
  authDomain: "kfscam-acbe4.firebaseapp.com",
  projectId: "kfscam-acbe4",
  storageBucket: "kfscam-acbe4.firebasestorage.app",
  messagingSenderId: "203415123710",
  appId: "1:203415123710:web:a7e787c8f9876629ab97af",
  measurementId: "G-ZFSJGMFMGR"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app)

export { auth, db, storage };